export default __webpack_public_path__ + "static/media/2cdddb8c42deb62ea22c1dcfa78fcc93.svg";